svg4everybody();

const APP = {

	name			: 'Квартэк :: Экраны для батарей',

	websiteWrapper	: $('#website-wrapper'),

	desktopXsWidth  : 1199,

	tabletWidth     : 991,

	tabletXsWidth   : 767,

	mobileWidth     : 599,

	mobileXsWidth   : 359,

	modalTrigger 	: $('.js-modal-trigger'),

	modalClose	 	: '.js-modal-close',

	modalClass 		: 'website-wrapper--modal-opened',

	inputTel	 	: $('.js-input-tel'),

	hiddenCarousel 	: 'carousel--hidden',

};
const setWidth = () => {
    APP.websiteWrapper.css({
        'max-width' : window.deviceWidth + 'px'
    });
}
const unsetWidth = () => {
    APP.websiteWrapper.removeAttr('style');
}

const screenElement = () => {

    const parent      = '.js-screens-element';
    const link        = $('.js-screens-element-link');
    const activeClass = 'screens-element--active';

    link.on('click', function(e){
        const element = $(this).parents(parent);

        $(parent).removeClass(activeClass);

        if ( !element.hasClass(activeClass) ) {
            element.addClass(activeClass);
        }
        else {
            element.removeClass(activeClass);
        }
    });

    $(document).on("mouseup touchend", function(e){
        if (!$(parent).is(e.target) && $(parent).has(e.target).length === 0) {
            $(parent).removeClass(activeClass);
        }
    });
}
const seriesElement = () => {

    const parent      = '.js-series-element';
    const link        = $('.js-series-element-link');
    const activeClass = 'series-element--active';

    link.on('click', function(e){
        const element = $(this).parents(parent);

        $(parent).removeClass(activeClass);

        if ( !element.hasClass(activeClass) ) {
            element.addClass(activeClass);
        }
        else {
            element.removeClass(activeClass);
        }
    });

    $(document).on("mouseup touchend", function(e){
        if (!$(parent).is(e.target) && $(parent).has(e.target).length === 0) {
            $(parent).removeClass(activeClass);
        }
    });
}
//https://igorescobar.github.io/jQuery-Mask-Plugin/docs.html
const inputTel = (id) => {
    if ( id.length ) {
        id.mask('+7 (000) 000-00-00',  {placeholder: "+7 (xxx) xxx-xx-xx"});
    }
}
const orderFormValidator = () => {

    const order = $('#order-form');

    if ( order.length ) {
        $.validator.setDefaults({
            debug: true,
            success: 'valid'
        });
        $.validator.addMethod("validateEmail", function(value, element) {
            if (/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(value)) {
                return true;
            } else {
                return false;
            }
        });
        $.validator.addMethod("validatePhone", function (value, element) {
            return value.replace(/\D+/g, '').length > 10;
        });

        order.validate({
            errorClass: "input--error",
            validClass: "input--success",
            rules : {
                orderName : {
                    required : true
                },
                orderTel : {
                    required      : true,
                    validatePhone : true
                },
                orderEmail : {
                    required      : true,
                    validateEmail : true
                },
                orderAgreement : {
                    required      : true
                }
            },
            messages : {
                orderName      : 'Введите Ваше имя',
                orderTel       : 'Введите телефон',
                orderEmail     : 'Введите корректный e-mail',
                orderAgreement : ''
            },

            errorPlacement: function(error, element) {
                const parent = element.parents('.js-input');
                error.appendTo(parent);
            },
            highlight: function(element, errorClass, validClass) {
                $(element).parents('.js-input').addClass(errorClass).removeClass(validClass);
            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).parents('.js-input').removeClass(errorClass).addClass(validClass);
            },
            onfocusout: function(element) {
                if (!this.checkable(element) && (element.name in this.submitted || !this.optional(element))) {
                    this.element(element);
                }
            },
            submitHandler: function() {
                //sending data goes here
            }
        });
    }
}
const animation = () => {

    const animatic = new WOW (
        {
            boxClass        : 'wow',
            animateClass    : 'animated',
            offset          : 200,
            mobile          : false,
            scrollContainer : '#website-wrapper',
            resetAnimation  : false,
            callback        : function(box) {}
        }
    );

    animatic.init();

}
function scroll2() {
    const link = $('.js-scroll-link');

    link.on('click', function(e){
        e.preventDefault();
        APP.websiteWrapper.scrollTo(this.hash, this.hash);
    });

}
'use strict';

class MobileSeries
{

    constructor()
    {
        this.primary  = $('.js-series-element-mobile-primary');
        this.element  = $('.js-series-element').not('.js-series-element-mobile-primary');
        this.elements = $('.js-series-element');
        this.window   = $(window);
        this.bindEvents();
    }

    bindEvents()
    {
        this.window.on('load resize', this.checkClick.bind(this));
        this.window.on('resize', this.sortElements.bind(this));
        this.element.on('click', this.moveElement.bind(this));
    }

    moveElement(e)
    {
        e.preventDefault();
        if ( !this.clickAllowed ) return false;
        let el = $(e.currentTarget);

        const elementInfo = this.getElementData(el);
        const primaryInfo = this.getElementData(this.primary);

        this.setElementData(el, primaryInfo);
        this.setElementData(this.primary, elementInfo);
    }

    setElementData(element, data)
    {
        element.find('.js-series-element-image').attr({
            'src'    : data.src,
            'srcset' : data.srcset
        });
        element.find('.js-series-element-title').text(data.title);
        element.find('.js-series-element-description').html(data.description);
    }

    getDefaultElementData(element)
    {
        return {
            src         : element.attr('data-series-src'),
            srcset      : element.attr('data-series-srcset'),
            title       : element.attr('data-series-title'),
            description : element.attr('data-series-description')
        }
    }

    getElementData(element)
    {
        const image = element.find('.js-series-element-image');

        return {
            src         : image.attr('src'),
            srcset      : image.attr('srcset'),
            title       : element.find('.js-series-element-link .js-series-element-title').text(),
            description : element.find('.js-series-element-description').html()
        }
    }

    checkClick()
    {
        if ( window.deviceWidth <= APP.tabletXsWidth ) {
            this.clickAllowed = true;
        } else {
            this.clickAllowed = false;
        }
    }

    sortElements()
    {
        if ( !this.clickAllowed )
        {
            this.elements.each($.proxy(function (i, element ) {

                const defaultInfo = this.getDefaultElementData($(element));
                const info        = this.getElementData($(element));

                if (defaultInfo.src != info.src)
                {
                    this.setElementData($(element), defaultInfo);
                }

            }, this));
        }
    }
}

const modal = (id) => {



    const modal = $(id.attr('href'));



    if ( modal.length ) {

        id.magnificPopup({

            type            :'inline',

            removalDelay    : 200,

            midClick        : true,

            callbacks       : {

                beforeOpen  : function() {

                    this.st.mainClass = this.st.el.attr('data-effect');

                },

                open        : function () {

                    setWidth();

                    APP.websiteWrapper.addClass(APP.modalClass);

                },

                close       : function () {

                    unsetWidth();

                    APP.websiteWrapper.removeClass(APP.modalClass);

                }

            }

        });

    }



    $(APP.modalClose).on('click', function(){

        closeModal();

    });

}

const closeModal = () => {

    $.magnificPopup.proto.close();

}


const selectStyler = () => {

    const select = $('.select select');

    if (select.length) {
        select.styler({
            selectSmartPositioning : false,
            selectSearch           : false
        });
    }

}

const hero = () => {

    const hero = $('.js-hero');

    if ( hero.length ) {
        hero.each(function(){

            const current   = $(this).find('.js-hero-current');
            const total     = $(this).find('.js-hero-total');

            $(this).on('init reInit afterChange', function(event, slick, currentSlide){
                $(this).removeClass(APP.hiddenCarousel);

                let i = (currentSlide ? currentSlide : 0) + 1;
                let totalSlides;

                //current slide
                if ( i < 10 ) {
                    i = '0'+i;
                }
                //total slides
                if (  slick.slideCount < 10 ) {
                    totalSlides = '/0'+slick.slideCount;
                }
                else {
                    totalSlides = '/'+slick.slideCount
                }

                current.text(i);
                total.text(totalSlides);
            });
            $(this).slick({
                slide           : '.hero__element',
                slidesToShow    : 1,
                adaptiveHeight  : true,
                arrows          : true,
                appendArrows    : $('.js-hero-controls', $(this)),
                prevArrow       : '<button type="button" class="slick-prev"><svg class="i"><use xlink:href="#chevron-left"/></svg></button>',
                nextArrow       : '<button type="button" class="slick-next"><svg class="i"><use xlink:href="#chevron-right"/></svg></button>',
                dots            : false,
                infinite        : false,
                responsive      : [
                    {
                        breakpoint: 599,
                        settings: {
                            dots   : true
                        }
                    }
                ]
            });
        });
    }
}

const counter = () => {

    const counter = '.js-counter';
    const remove  = $('.js-counter-remove');
    const add     = $('.js-counter-add');

    remove.on('click', function(){
        const min       = $(this).parents(counter).attr('data-min');
        const add       = $(this).parents(counter).find('.js-counter-add');
        const remove    = $(this).parents(counter).find('.js-counter-remove');
        const input     = $(this).parents(counter).find('.js-counter-input');
        let currentVal  = parseInt(input.val());

        if ( !isNaN(currentVal) && currentVal > min ) {
            add.attr('disabled', false);
            input.val(currentVal - 1);
        } else {
            input.val(min);
            remove.attr('disabled', true);
        }
        input.trigger('change');
    });
    add.on('click', function(){
        const max       = $(this).parents(counter).attr('data-max');
        const add       = $(this).parents(counter).find('.js-counter-add');
        const remove    = $(this).parents(counter).find('.js-counter-remove');
        const input     = $(this).parents(counter).find('.js-counter-input');
        let currentVal  = parseInt(input.val());

        if ( !isNaN(currentVal) && currentVal < max ) {
            remove.attr('disabled', false);
            input.val(currentVal + 1);
        } else {
            input.val(max);
            add.attr('disabled', true);
        }
        input.trigger('change');
    });
}

const mobileSlider = (width) => {

    const slider = $('.js-mobile-slider');

    if ( slider.length) {

        if (window.deviceWidth <= width) {
            slider.each(function(){
                let $this = $(this);
                if ( !$this.hasClass('slick-initialized') ) {
                    $this.slick({
                        autoplay        : true,
                        autoplaySpeed   : 2000,
                        infinite        : false,
                        slidesToShow    : 1,
                        slidesToScroll  : 1,
                        slide           : '.mobile-slider__element',
                        arrows          : false,
                        dots            : false,
                        variableWidth   : true,
                        adaptiveHeight  : true
                    });
                }
                else {
                    $this.slick('refresh');
                }
            });
        }
        else {
            slider.each(function(){
                let $this = $(this);
                if ( $this.hasClass('slick-initialized') ) {
                    $this.slick('unslick');
                }
            });
        }

    }

}


$(function() {

	console.log(APP.name);



    animation();

    hero();

    modal(APP.modalTrigger);

    selectStyler();

    screenElement();

    seriesElement();

    counter();

    inputTel(APP.inputTel);

    orderFormValidator();

    scroll2();

    const mobileSeries = new MobileSeries();

});



$(window).on('load resize', function(){

    window.deviceWidth = APP.websiteWrapper.width();



    mobileSlider(APP.mobileWidth);

});